module.exports = __webpack_public_path__ + "img/support.6062fe56.jpg";